import { Paragraph } from '@sbab-ui/components'
import { Suggestion } from '../../api/httpHandlers'
import SlideOver from './SlideOver'
import { getHeatingDescriptionById } from './heatingDescription'

interface Props {
  suggestion: Suggestion
  open: boolean
  toggleOpen: () => void
  processedTitle: string
}

export default function SuggestionExplanation({ suggestion, processedTitle }: Readonly<Props>) {
  const heatingDescription = getHeatingDescriptionById(suggestion.id)

  return (
    <SlideOver title={processedTitle}>
      <Paragraph className="!mb-10 whitespace-pre-line">{heatingDescription}</Paragraph>
      <Paragraph className="inline !font-bold">Bra att veta: </Paragraph>
      <Paragraph className="inline">
        Du kan läsa mer om olika typer av värmekällor, solceller och hur du kan spara energi på{' '}
        <a href="https://www.energimyndigheten.se/" className="!text-semantic-link underline">
          energimyndigheten.se
        </a>{' '}
      </Paragraph>
    </SlideOver>
  )
}
